import { render, staticRenderFns } from "./sub-visual-office.vue?vue&type=template&id=ddebc954&scoped=true&"
import script from "./sub-visual-office.vue?vue&type=script&lang=js&"
export * from "./sub-visual-office.vue?vue&type=script&lang=js&"
import style0 from "./sub-visual-office.vue?vue&type=style&index=0&id=ddebc954&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddebc954",
  null
  
)

export default component.exports